module.exports = __webpack_public_path__ + "img/douyin.9cec14db.png";